import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/material/material.module';
import { Payment } from '../../../../core/generated';
import { EnumDescriptionPipe } from '../../../../shared/pipes/enum-description.pipe';

export interface PaymentDialogData {
  payment?: Payment;
}

@Component({
  selector: 'app-payment-dialog',
  standalone: true,
  imports: [MaterialModule, FormsModule, EnumDescriptionPipe],
  templateUrl: './payment-dialog.component.html',
  styleUrl: './payment-dialog.component.scss'
})
export class PaymentDialogComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<PaymentDialogComponent>);

  paymentMethods: Payment.MethodEnum[] = [
    'CREDIT_CARD',
    'PIX',
    'BOLETO',
    'BANK_TRANSFER',
  ];

  paymentStatus: Payment.StatusEnum[] = [
    'PENDING_PAYMENT',
    'PARTIALLY_PAID',
    'PAID',
    'FAILED',
  ];

  paymentForm = this.fb.group({
    id: [null as number | null],
    accessPlanId: [null as number | null, Validators.required],
    totalAmount: [0, [Validators.required, Validators.min(0.01)]],
    numberOfInstallments: [1, [Validators.required, Validators.min(1)]],
    method: ['CREDIT_CARD' as Payment.MethodEnum, Validators.required],
    status: ['PENDING_PAYMENT' as Payment.StatusEnum, Validators.required],
    planCpfcnpj: [null as string | null],
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: PaymentDialogData) {
    if (data.payment) {
      this.paymentForm.patchValue({
        id: data.payment.id ?? null,
        accessPlanId: data.payment.accessPlanId ?? null,
        totalAmount: data.payment.totalAmount ?? 0,
        numberOfInstallments: data.payment.numberOfInstallments ?? 1,
        method: data.payment.method ?? 'CREDIT_CARD',
        status: data.payment.status ?? 'PENDING_PAYMENT',
        planCpfcnpj: data.payment.planCpfcnpj ?? null,
      });
    }
  }

  get isEditMode(): boolean {
    return !!this.data.payment;
  }

  onSave(): void {
    if (this.paymentForm.valid) {
      this.dialogRef.close(this.paymentForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
